import { useEffect } from 'react'

import { Icon } from '@fv/client-components'
import { authUri } from '@fv/client-core'

import { fetchAdminContext } from '@/hooks/useAdminContext'

export const Login = () => {
  useEffect(() => {
    const checkContext = async () => {
      try {
        const result = await fetchAdminContext()

        if (result.sessionId) {
          window.location.href = '/'
        }
      } catch (e) {
        window.location.href = `${authUri}/signin/admin`
      }
    }

    checkContext()
  }, [])

  return (
    <h1>
      <Icon icon="spinner" />
    </h1>
  )
}
